<div class="flex justify-center h-full">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Confirm Registration</h2>
    <form id="confirmRegistationForm" #confirmRegistationForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Email Address</mat-label>
        <input matInput type="text" name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Verification Code</mat-label>
        <input matInput type="text" name="ConfirmationCode" id="ConfirmationCode" required [(ngModel)]="model.ConfirmationCode" #ConfirmationCode="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <button mat-flat-button color="primary" type="submit" class="my-2" [disabled]="!confirmRegistationForm.form.valid || processing">CONFIRM REGISTRATION</button>

    </form>
    <button class="my-1 self-center" mat-button color="accent" [routerLink]="['/resend']" style="color: #545859">SEND A NEW CODE</button>
  </div>

</div>
